var conference = window.conference || {};

conference.cart = {
	currentLang: undefined,
	init: function() {
		this.bindEvents();
	},
	bindEvents: function() {
		$('.cart__toggle').unbind().on('click touchstart', function(event) {
			event.preventDefault();
			$('body').toggleClass('cart-open');
		});
		$('.conferenceCartAddHotel').unbind().on('click touchstart', function(event) {
			event.preventDefault();
			conference.cart.add(event);
		});
		$('.conferenceCartRemoveHotel').unbind().on('click touchstart', function(event) {
			event.preventDefault();
			conference.cart.remove(event);
		});
		conference.cart.bindBodyClick();
		conference.cart.bindEscapeKeypress();
	},
	bindBodyClick: function() {
		var $body = $('body');
		$(document).on('click touchstart', function(e) {
			if ($body.is('.cart-open')) {
				var container = $("#conferenceCart, .hotel__buttonWrap");

				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$body.removeClass('cart-open');
				}
			}
		});
	},
	bindEscapeKeypress: function() {
		$(document).keyup(function(e) {
			if (e.key === 'Escape') {
				$('body').removeClass('cart-open');
			}
		});
	},
	add: function(event) {
		var $button = $(event.target),
			hotel = $button.data('hotel');

		$.ajax({
			url: conference.cart.getLocalUrl('add'),
			data: {
				hotel: hotel
			}
		}).done(function() {
			conference.cart.update();
			setTimeout(function() {
				$('body').addClass('cart-open');
			}, 200);
		});
	},
	remove: function() {
		var $button = $(event.target),
			hotel = $button.data('hotel');
		$.ajax({
			url: conference.cart.getLocalUrl('remove'),
			data: {
				hotel: hotel
			}
		}).done(conference.cart.update)
	},
	update: function() {
		var $cart = $('#conferenceCart'),
			url = conference.cart.getLocalUrl('index');
		if ($('#conferenceBookingForm').length) {
			url = conference.cart.getLocalUrl('index/booking')
		}
		$.ajax({
			url: url,
		}).done(function(r) {
			$cart.replaceWith(r);
			conference.cart.bindEvents();
		});
	},
	getLocalUrlPrefix: function() {
		if (conference.cart.currentLang === undefined) {
			conference.cart.currentLang = $('html').attr('lang');
		}
		return '/_/' + conference.cart.currentLang + '/conference/cart/';
	},
	getLocalUrl: function(url) {
		return conference.cart.getLocalUrlPrefix() + url;
	}
};
